// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {

  apiKey: "AIzaSyCb2dk6ir6GpmpAwY7HE8olVNdYCjg76Nk",
  authDomain: "alinfaaq-6bdc0.firebaseapp.com",
  projectId: "alinfaaq-6bdc0",
  storageBucket: "alinfaaq-6bdc0.firebasestorage.app",
  messagingSenderId: "685079227897",
  appId: "1:685079227897:web:763fbe44a908870bc56128",
  measurementId: "G-NW9Z1DEBEE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {db};